import { create } from 'zustand';
import type { EnrichmentStore, EnrichmentFromType, TableEnrichmentSelectionState } from './types';

export const useEnrichmentStore = create<EnrichmentStore>(set => ({
  enrichmentFrom: undefined,

  setEnrichmentFrom: (data: EnrichmentFromType) => {
    set({ enrichmentFrom: data });
  },

  clearEnrichmentFrom: () => {
    set({ enrichmentFrom: undefined });
  },

  tableEnrichmentSelection: undefined,

  setTableEnrichmentSelection: (data: TableEnrichmentSelectionState) => {
    set({ tableEnrichmentSelection: data });
  },

  clearTableEnrichmentSelection: () => {
    set({ tableEnrichmentSelection: undefined });
  },
}));
